import { render, staticRenderFns } from "./FilmTypeList.vue?vue&type=template&id=2ea12c97&scoped=true"
import script from "./FilmTypeList.vue?vue&type=script&lang=js"
export * from "./FilmTypeList.vue?vue&type=script&lang=js"
import style0 from "./FilmTypeList.vue?vue&type=style&index=0&id=2ea12c97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea12c97",
  null
  
)

export default component.exports